import type { IconNode } from '../types';

/**
 * @name pepper-chilli
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTggN1Y0YTIgMiAwIDAgMC00IDAiIC8+CiAgPHBhdGggZD0iTTE0IDEwczIgMCA0IDJjMi0yIDQtMiA0LTIiIC8+CiAgPHBhdGggZD0iTTIyIDEwYzAgNi42LTUuNCAxMi0xMiAxMi00LjQgMC04LTIuNy04LTZ2LS40QzMuMyAxNy4xIDUgMTggNyAxOGMzLjkgMCA3LTMuNiA3LTggMC0xLjcgMS4zLTMgMy0zaDJjMS43IDAgMyAxLjMgMyAzIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/pepper-chilli
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const pepperChilli: IconNode = [
  ['path', { d: 'M18 7V4a2 2 0 0 0-4 0', key: '1preb3' }],
  ['path', { d: 'M14 10s2 0 4 2c2-2 4-2 4-2', key: '2o2v2i' }],
  [
    'path',
    {
      d: 'M22 10c0 6.6-5.4 12-12 12-4.4 0-8-2.7-8-6v-.4C3.3 17.1 5 18 7 18c3.9 0 7-3.6 7-8 0-1.7 1.3-3 3-3h2c1.7 0 3 1.3 3 3',
      key: 'wd80z2',
    },
  ],
];

export default pepperChilli;
